import isObject from 'lodash/isObject';
import isEmpty from 'lodash/isEmpty';

const gtmInitialise = ({ gtmId, events = {}, dataLayer = undefined, dataLayerName = 'dataLayer', auth = '', preview = '' }) => {
  const gtm_auth = `&gtm_auth=${auth}`;
  const gtm_preview = `&gtm_preview=${preview}`;

  const noScriptTag = () => {
    const element = document.createElement('noscript');
    element.insertAdjacentHTML(
      'afterbegin',
      `<iframe src="//www.googletagmanager.com/ns.html?id=${gtmId}${gtm_auth}${gtm_preview}&gtm_cookies_win=x"height="0" width="0" style="display:none;visibility:hidden" id="tag-manager"></iframe>`,
    );
    return element;
  };

  const scriptTag = () => {
    const element = document.createElement('script');
    element.insertAdjacentHTML(
      'afterbegin',
      `(function(w,d,s,l,i){w[l]=w[l]||[];
      w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js', ${JSON.stringify(events).slice(1, -1)}});
      var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';
      j.defer=true;j.src='//www.googletagmanager.com/gtm.js?id='+i+dl+'${gtm_auth}${gtm_preview}&gtm_cookies_win=x';
      f.parentNode.insertBefore(j,f);
      })(window,document,'script','${dataLayerName}','${gtmId}');`,
    );
    return element;
  };

  const dataLayerTag = () => {
    const element = document.createElement('script');
    element.insertAdjacentHTML(
      'afterbegin',
      `window.${dataLayerName} = window.${dataLayerName} || [];window.${dataLayerName}.push(${JSON.stringify(dataLayer)})`,
    );
    return element;
  };

  if (isObject(dataLayer) && !isEmpty(dataLayer)) document.head.appendChild(dataLayerTag());
  document.head.appendChild(scriptTag());
  document.body.appendChild(noScriptTag());
};

export default gtmInitialise;
